<template>
  <div>
    <h1>期权信息管理</h1>

     <!-- 新增按钮 -->
    <el-button type="primary" @click="showAddDialog = true" style="margin-bottom: 20px">
      新增期权
    </el-button>
     <!-- 数据表格 -->
    <el-table :data="options" border style="width: 100%"  :row-class-name="row => `row-${row.id}`">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="underlying_name" label="标的名称" />
      <el-table-column prop="underlying_code" label="标的代码" />
      <el-table-column prop="inquiry_period" label="询价周期" />
      <el-table-column prop="lockup_period" label="锁定期" />
      <el-table-column prop="inquiry_structure" label="询价结构" />
      <el-table-column prop="strike_price" label="执行价" align="right" />
      <el-table-column prop="knock_in_price" label="敲入价" align="right" />
      <el-table-column prop="knock_out_price" label="敲出价" align="right" />
      <el-table-column prop="knock_down" label="降敲" align="right" />
      <el-table-column prop="margin" label="保证金" align="right" />
      <el-table-column prop="max_loss" label="最大亏损" align="right" />
      <el-table-column prop="coupon" label="票息" align="right" />
      <el-table-column prop="institution" label="机构" align="right" />
      <el-table-column prop="date" label="日期" align="right" />


      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button
            size="small"
            @click="handleEdit(scope.row)"
            type="primary"
            plain
          >
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="deleteOption(scope.row.id)"
            plain
          >
            删除
          </el-button>
          <el-button type="success" @click="handleCopy(scope.row)">复制</el-button>

        </template>
      </el-table-column>
    </el-table>

<!-- 新增弹窗 -->
<el-dialog
  v-model="showAddDialog"
  title="新增期权"
  width="45%"
  :before-close="handleClose"
>
  <el-form
    ref="addFormRef"
    :model="newOption"
    :rules="rules"
    label-width="120px"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="标的名称" prop="underlying_name">
          <el-input v-model="newOption.underlying_name" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="标的代码" prop="underlying_code">
          <el-input v-model="newOption.underlying_code" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
       <el-form-item label="询价周期" prop="inquiry_period">
          <el-select
            v-model="newOption.inquiry_period"
            placeholder="请选择询价周期"    style="width: 100%"
          >
            <el-option
              v-for="period in inquiryPeriodOptions"
              :key="period.value"
              :label="period.label"
              :value="period.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
       <el-form-item label="锁定期" prop="lockup_period">
          <el-select
            v-model="newOption.lockup_period"
            placeholder="请选择锁定期"    style="width: 100%"
          >
            <el-option
              v-for="period in inquiryPeriodOptions"
              :key="period.value"
              :label="period.label"
              :value="period.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="询价结构" prop="inquiry_structure">
          <el-select
            v-model="newOption.inquiry_structure"
            placeholder="请选择询价结构"            style="width: 100%"
          >
            <el-option
              v-for="option in inquiryStructureOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="执行价" prop="strike_price">
          <el-input
            v-model="newOption.strike_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="敲入价" prop="knock_in_price">
          <el-input
            v-model="newOption.knock_in_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="敲出价" prop="knock_out_price">
          <el-input
            v-model="newOption.knock_out_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="降敲" prop="knock_down">
          <el-input
            v-model="newOption.knock_down"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="保证金" prop="margin">
          <el-input
            v-model="newOption.margin"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="最大亏损" prop="max_loss">
          <el-input
            v-model="newOption.max_loss"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="票息" prop="coupon">
          <el-input
            v-model="newOption.coupon"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="机构" prop="institution">
          <el-select
            v-model="newOption.institution"
            placeholder="请选择机构"        style="width: 100%"
          >
            <el-option
              v-for="option in institutionOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="submitForm('addFormRef')">保存</el-button>
      <el-button @click="resetForm('addFormRef')">重置</el-button>
    </el-form-item>
  </el-form>
</el-dialog>


   <!-- 编辑弹窗 -->
<el-dialog
  v-model="showEditDialog"
  title="编辑期权"
  width="45%"
  :before-close="handleClose"
>
  <el-form
    ref="editFormRef"
    :model="editingOption"
    :rules="rules"
    label-width="120px"
  >
    <!-- 字段布局与新增表单完全一致 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="标的名称" prop="underlying_name">
          <el-input v-model="editingOption.underlying_name" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="标的代码" prop="underlying_code">
          <el-input v-model="editingOption.underlying_code" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="询价周期" prop="inquiry_period">
          <el-select
            v-model="editingOption.inquiry_period"
            placeholder="请选择询价周期"    style="width: 100%"
          >
            <el-option
              v-for="period in inquiryPeriodOptions"
              :key="period.value"
              :label="period.label"
              :value="period.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
       <el-form-item label="锁定期" prop="lockup_period">
          <el-select
            v-model="editingOption.lockup_period"
            placeholder="请选择锁定期"    style="width: 100%"
          >
            <el-option
              v-for="period in inquiryPeriodOptions"
              :key="period.value"
              :label="period.label"
              :value="period.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
       <el-form-item label="询价结构" prop="inquiry_structure">
          <el-select
            v-model="editingOption.inquiry_structure"
            placeholder="请选择询价结构"            style="width: 100%"
          >
            <el-option
              v-for="option in inquiryStructureOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="执行价" prop="strike_price">
          <el-input
            v-model="editingOption.strike_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="敲入价" prop="knock_in_price">
          <el-input
            v-model="editingOption.knock_in_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="敲出价" prop="knock_out_price">
          <el-input
            v-model="editingOption.knock_out_price"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="降敲" prop="knock_down">
          <el-input
            v-model="editingOption.knock_down"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="保证金" prop="margin">
          <el-input
            v-model="editingOption.margin"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="最大亏损" prop="max_loss">
          <el-input
            v-model="editingOption.max_loss"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="票息" prop="coupon">
          <el-input
            v-model="editingOption.coupon"
            :precision="2"
            :step="0.01"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="机构" prop="institution">
          <el-select
            v-model="editingOption.institution"
            placeholder="请选择机构"
            style="width: 100%"
          >
            <el-option
              v-for="option in institutionOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>


    <el-form-item>
      <el-button type="primary" @click="submitForm('editFormRef')">更新</el-button>
      <el-button @click="resetForm('editFormRef')">重置</el-button>
    </el-form-item>
  </el-form>
</el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  data() {
    return {
      // 表单验证规则
      rules: {
        underlying_name: [
          { required: true, message: '请输入标的名称', trigger: 'blur' }
        ],
        underlying_code: [
          { required: true, message: '请输入标的代码', trigger: 'blur' }
        ],
        inquiry_period: [
          { required: true, message: '请选择询价周期', trigger: 'change'}
        ],
         institution: [
            { required: true, message: '请选择机构', trigger: 'change' }
        ],
        lockup_period: [
          { required: true, message: '请输入锁定期', trigger: 'change' }
        ],
        inquiry_structure: [
          { required: true, message: '请输入询价结构', trigger: 'blur' }
        ],
        strike_price: [
          { required: true, message: '请输入执行价', trigger: 'blur' }
        ],
        knock_in_price: [
          { required: true, message: '请输入敲入价', trigger: 'blur' }
        ],
        knock_out_price: [
          { required: true, message: '请输入敲出价', trigger: 'blur' }
        ],
        knock_down: [
          { required: true, message: '请输入降敲值', trigger: 'blur' }
        ],
        margin: [
          { required: true, message: '请输入保证金', trigger: 'blur' }
        ],
        max_loss: [
          { required: true, message: '请输入最大亏损', trigger: 'blur' }
        ],
        coupon: [
          { required: true, message: '请输入票息', trigger: 'blur' }
        ]
      },
      // 数据状态
      options: [],
      newOption: {
        underlying_name: '',
        underlying_code: '',
        inquiry_period: '1M',
        lockup_period: '',
        inquiry_structure: '雪球',
        strike_price: 0,
        knock_in_price: 0,
        knock_out_price: 0,
        knock_down: 0,
        margin: 0,
        max_loss: 0,
        coupon: 0,
        institution:"银河德睿"
      },
      editingOption: null,
      showAddDialog: false,
      showEditDialog: false,
      inquiryPeriodOptions:
      [
          { label: '1M', value: '1M' },
          { label: '2M', value: '2M' },
          { label: '3M', value: '3M' },
          { label: '6M', value: '6M' },
          { label: '12M', value: '12M' },
          { label: '24M', value: '24M' }
      ],
      institutionOptions: [
      { label: '银河德睿', value: '银河德睿' },
      { label: '南华资本', value: '南华资本' },
      { label: '国君', value: '国君' },
      { label: '中信证券', value: '中信证券' },
      { label: '中信中证', value: '中信中证' }
    ],
     inquiryStructureOptions: [
      { label: '雪球', value: '雪球' },
      { label: '欧式', value: '欧式' },
      { label: '美式', value: '美式' },
      // 其他选项
    ],

    };
  },
  methods: {
    // 表单重置
    resetForm(formName) {
      if (formName === 'addFormRef') {
        this.$refs.addFormRef.resetFields();
        this.newOption = {
          underlying_name: '',
          underlying_code: '',
          inquiry_period: '1M', // 恢复默认值
          lockup_period: '',
          inquiry_structure: '',
          institution: '', // 新增字段
          strike_price: 0,
          knock_in_price: 0,
          knock_out_price: 0,
          knock_down: 0,
          margin: 0,
          max_loss: 0,
          coupon: 0
        };
      } else if (formName === 'editFormRef') {
        this.$refs.editFormRef.resetFields();
        this.editingOption = null;
      }
    },
    // 初始化数据
    async fetchOptions() {
      try {
        const response = await axios.get('/api/options');
        this.options = response.data;
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },
     async handleCopy(row) {
      try {
        // 深拷贝当前行数据（避免直接修改原始数据）
        const data = JSON.parse(JSON.stringify(row));

        // 定义字段与标签的映射关系
        const fieldLabels = {
          underlying_name: '标的名称',
          underlying_code: '标的代码',
          inquiry_period: '询价周期',
          lockup_period: '锁定期',
          inquiry_structure: '询价结构',
          strike_price: '执行价',
          knock_in_price: '敲入价',
          knock_out_price: '敲出价',
          knock_down: '降敲',
          margin: '保证金',
          max_loss: '最大亏损',
          coupon: '票息',
          institution: '机构'
        };

        // 格式化输出字符串
        let formattedStr = '';
        for (const key in fieldLabels) {
          if (data[key] !== undefined) {
            formattedStr += `${fieldLabels[key]}: ${data[key]}\n`;
          }
        }

        // 复制到剪贴板
        await navigator.clipboard.writeText(formattedStr);
        ElMessage.success('数据已复制到剪贴板');
      } catch (error) {
        ElMessage.error('复制失败，请手动复制');
      }
    },

    // 新增/更新操作
    async submitForm(formName) {
      if (formName === 'addFormRef') {
        this.$refs.addFormRef.validate(async (valid) => {
          if (valid) {
            try {
              await axios.post('/api/options', this.newOption);
              ElMessage.success('新增成功');
              this.showAddDialog = false;
              this.resetForm('addFormRef');
              this.fetchOptions();
            } catch (error) {
              console.error('Error creating option:', error);
            }
          }
        });
      } else if (formName === 'editFormRef') {
        this.$refs.editFormRef.validate(async (valid) => {
          if (valid) {
            try {
              await axios.put(`/api/options/${this.editingOption.id}`, this.editingOption);
              ElMessage.success('更新成功');
              this.showEditDialog = false;
              this.fetchOptions();
            } catch (error) {
              console.error('Error updating option:', error);
            }
          }
        });
      }
    },
    // 编辑操作
    handleEdit(row) {
      this.editingOption = JSON.parse(JSON.stringify(row)); // 深拷贝
      this.showEditDialog = true;
    },
    // 删除操作
    deleteOption(id) {
      ElMessageBox.confirm(
        '确定删除该期权信息？',
        '删除确认',
        {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(async () => {
          try {
            await axios.delete(`/api/options/${id}`);
            ElMessage.success('删除成功');
            this.fetchOptions();
          } catch (error) {
            console.error('Error deleting option:', error);
          }
        });
    }
  },
  mounted() {
    this.fetchOptions(); // 初始化加载数据
  }
};
</script>


<style scoped>
/* 自定义样式覆盖 */
.el-input {
  width: 100%;
}

.el-table {
  margin-top: 20px;
}

/* 弹窗按钮组间距 */
.el-form-item__content {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
</style>
